import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetScope } from '../features/authentication/hooks/useToken';
import { useClientUser } from '../providers/client.provider';
import { useTheme } from '@mui/material';
import { FaChartLine } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import useFlagsHook from '../hooks/useFlags.hook';
import { AllowByFlag } from '../components/permission';

// Corporate Menu Component

const CorporateMenu = () => {
  const { isFlagEnabled, getFlagValue } = useFlagsHook();
  const flag = isFlagEnabled('SEARCH_ORDER_PAGE');
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const apiTokens = localStorage.getItem('apiToken');
  const clientUser = JSON.parse(apiTokens) || useClientUser();
  const clientUserRole = clientUser?.userRole;
  let customerId = GetScope();

  const icons = true;
  const customersExpanded = location.pathname.startsWith('/customers');

  // REDUX
  const sidebarExpanded = useSelector((state) => state.ui.sidebarExpanded);

  return (
    <>
      <ul className={`admin-navbar-nav navbar-nav mui-mode-${theme.palette.mode}`}>
        {clientUserRole === 'CustomerService' ? (
          <li className={`nav-item ${customersExpanded ? 'active' : ''}`}>
            <Link className='nav-link' to='/customers'>
              {icons && (
                <span className='nav-link-icon d-md-none d-lg-inline-block'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='icon icon-thick icon-tabler icon-tabler-users'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    strokeWidth='2'
                    stroke='currentColor'
                    fill='none'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                    <circle cx='9' cy='7' r='4'></circle>
                    <path d='M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2'></path>
                    <path d='M16 3.13a4 4 0 0 1 0 7.75'></path>
                    <path d='M21 21v-2a4 4 0 0 0 -3 -3.85'></path>
                  </svg>
                </span>
              )}
              <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                {t('associates')}
              </span>
            </Link>
          </li>
        ) : clientUserRole === 'Compliance' ? (
          <li className={`nav-item ${customersExpanded ? 'active' : ''}`}>
            <Link className='nav-link' to='/customers'>
              {icons && (
                <span className='nav-link-icon d-md-none d-lg-inline-block'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='icon icon-thick icon-tabler icon-tabler-users'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    strokeWidth='2'
                    stroke='currentColor'
                    fill='none'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                    <circle cx='9' cy='7' r='4'></circle>
                    <path d='M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2'></path>
                    <path d='M16 3.13a4 4 0 0 1 0 7.75'></path>
                    <path d='M21 21v-2a4 4 0 0 0 -3 -3.85'></path>
                  </svg>
                </span>
              )}
              <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                {t('associates')}
              </span>
            </Link>
          </li>
        ) : (
          <>
            {getFlagValue('NEW_ADMIN_DASHBOARD') === '1' && (
              <li
                className={`nav-item ${location.pathname == '/dashboard' ? 'active' : ''}`}
              >
                <Link className='nav-link' to='/dashboard'>
                  {icons && (
                    <span className='nav-link-icon d-md-none d-lg-inline-block'>
                      <FaChartLine fontWeight={'26px'} />
                    </span>
                  )}
                  <span
                    className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}
                  >
                    {t('dashboard')}
                  </span>
                </Link>
              </li>
            )}
            <li className={`nav-item ${customersExpanded ? 'active' : ''}`}>
              <Link className='nav-link' to='/customers'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-users'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                      <circle cx='9' cy='7' r='4'></circle>
                      <path d='M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2'></path>
                      <path d='M16 3.13a4 4 0 0 1 0 7.75'></path>
                      <path d='M21 21v-2a4 4 0 0 0 -3 -3.85'></path>
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('associates')}
                </span>
              </Link>
            </li>
            <li className={`nav-item ${location.pathname == '/reports' ? 'active' : ''}`}>
              <Link className='nav-link' to='/reports'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-chart-bar'
                      width='40'
                      height='40'
                      viewBox='0 0 24 24'
                      strokeWidth='1'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                      <path d='M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z'></path>
                      <path d='M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z'></path>
                      <path d='M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z'></path>
                      <path d='M4 20l14 0'></path>
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('reports')}
                </span>
              </Link>
            </li>
            {flag && (
              <li
                className={`nav-item ${location.pathname == '/search-order' ? 'active' : ''}`}
              >
                <Link className='nav-link' to='/search-order'>
                  {icons && (
                    <span className='nav-link-icon d-md-none d-lg-inline-block'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        className='icon icon-thick icon-tabler icons-tabler-outline icon-tabler-truck-delivery'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                        <path d='M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                        <path d='M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5' />
                        <path d='M3 9l4 0' />
                      </svg>
                    </span>
                  )}
                  <span
                    className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}
                  >
                    {t('searchOrders')}
                  </span>
                </Link>
              </li>
            )}
            <AllowByFlag flagKey='KYC_ADMIN'>
              <li
                className={`nav-item ${location.pathname == '/tools/kyc' ? 'active' : ''}`}
              >
                <Link className='nav-link' to='/tools/kyc'>
                  {icons && (
                    <span className='nav-link-icon d-md-none d-lg-inline-block'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='icon icon-thick icon-tabler icon-tabler-shield-check'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        strokeWidth='2'
                        stroke='currentColor'
                        fill='none'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                        <path d='M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3'></path>
                        <path d='M9 12l2 2l4 -4'></path>
                      </svg>
                    </span>
                  )}
                  <span
                    className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}
                  >
                    {t('kycVerification')}
                  </span>
                </Link>
              </li>
            </AllowByFlag>
            {/* <li className={`nav-item ${location.pathname == '/merchants' ? 'active' : ''}`}>
              <Link className='nav-link' to='/merchants'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-chart-bar'
                      width='40'
                      height='40'
                      viewBox='0 0 24 24'
                      strokeWidth='1'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                      <path d='M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z'></path>
                      <path d='M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z'></path>
                      <path d='M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z'></path>
                      <path d='M4 20l14 0'></path>
                    </svg>
                  </span>
                )}
                <span className='nav-link-title'>{t('merchants')}</span>
              </Link>
            </li> */}
            <li className={`sidebar-header ${!sidebarExpanded ? 'hide-text' : ''}`}>
              <div className='d-flex align-items-center '>
                <span className='me-2'>{t('commissions')}</span>
                <div
                  className='flex-grow-1'
                  style={{
                    borderTop: '1px solid #80a0a9', // 👈 your custom color
                    opacity: 0.6,
                  }}
                ></div>
              </div>
            </li>
            <li
              className={`nav-item ${location.pathname == '/commissions/periods' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/commissions/periods'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-calendar-dollar'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3' />
                      <path d='M16 3v4' />
                      <path d='M8 3v4' />
                      <path d='M4 11h12.5' />
                      <path d='M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5' />
                      <path d='M19 21v1m0 -8v1' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('commissionPeriods')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/commissions/payables' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/commissions/payables'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-coin'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                      <circle cx='12' cy='12' r='9'></circle>
                      <path d='M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1'></path>
                      <path d='M12 7v10'></path>
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('payables')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/commissions/paid' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/commissions/paid'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-wallet'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12' />
                      <path d='M20 12v4h-4a2 2 0 0 1 0 -4h4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('paid')}
                </span>
              </Link>
            </li>
            <li className={` sidebar-header ${!sidebarExpanded ? 'hide-text' : ''}`}>
              <div className='d-flex align-items-center '>
                <span className='me-2'>{t('inventory')}</span>
                <div
                  className='flex-grow-1'
                  style={{
                    borderTop: '1px solid #80a0a9', // 👈 your custom color
                    opacity: 0.6,
                  }}
                ></div>
              </div>
            </li>
            <li
              className={`nav-item ${location.pathname == '/inventory/products' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/inventory/products'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-qrcode'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
                      <path d='M7 17l0 .01' />
                      <path d='M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
                      <path d='M7 7l0 .01' />
                      <path d='M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z' />
                      <path d='M17 7l0 .01' />
                      <path d='M14 14l3 0' />
                      <path d='M20 14l0 .01' />
                      <path d='M14 14l0 3' />
                      <path d='M14 20l3 0' />
                      <path d='M17 17l3 0' />
                      <path d='M20 17l0 3' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('products')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == `/inventory/products/unprocessedorders` ? 'active' : ''}`}
            >
              <Link className='nav-link' to={`/inventory/products/unprocessedorders`}>
                <span className='nav-link-icon d-md-none d-lg-inline-block'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='icon icon-thick icon-tabler icon-tabler-file-invoice'
                    width='40'
                    height='40'
                    viewBox='0 0 24 24'
                    strokeWidth='1'
                    stroke='currentColor'
                    fill='none'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
                    <path d='M14 3v4a1 1 0 0 0 1 1h4'></path>
                    <path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z'></path>
                    <path d='M9 7l1 0'></path>
                    <path d='M9 13l6 0'></path>
                    <path d='M13 17l2 0'></path>
                  </svg>
                </span>
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('unProcessedAutoShip')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/inventory/categories' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/inventory/categories'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-tag'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
                      <path d='M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('categories')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/inventory/stores' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/inventory/stores'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-building-store'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M3 21l18 0' />
                      <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4' />
                      <path d='M5 21l0 -10.15' />
                      <path d='M19 21l0 -10.15' />
                      <path d='M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('stores')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/subscription' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/subscription'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-building-store'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M3 21l18 0' />
                      <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4' />
                      <path d='M5 21l0 -10.15' />
                      <path d='M19 21l0 -10.15' />
                      <path d='M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('subscriptions')}
                </span>
              </Link>
            </li>
            {isFlagEnabled('SERVICES_PAGE') && (
              <li
                className={`nav-item ${location.pathname == '/services' ? 'active' : ''}`}
              >
                <Link className='nav-link' to='/services'>
                  {icons && (
                    <span className='nav-link-icon d-md-none d-lg-inline-block'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='icon icon-thick icon-tabler icon-tabler-building-store'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        strokeWidth='2'
                        stroke='currentColor'
                        fill='none'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M3 21l18 0' />
                        <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4' />
                        <path d='M5 21l0 -10.15' />
                        <path d='M19 21l0 -10.15' />
                        <path d='M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4' />
                      </svg>
                    </span>
                  )}
                  <span
                    className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}
                  >
                    {t('services')}
                  </span>
                </Link>
              </li>
            )}
            <li
              className={`nav-item ${location.pathname == '/glossary' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/glossary'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-building-store'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M3 21l18 0' />
                      <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4' />
                      <path d='M5 21l0 -10.15' />
                      <path d='M19 21l0 -10.15' />
                      <path d='M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('glossary')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/inventory/coupons' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/inventory/coupons'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-building-store'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M3 21l18 0' />
                      <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4' />
                      <path d='M5 21l0 -10.15' />
                      <path d='M19 21l0 -10.15' />
                      <path d='M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('coupons')}
                </span>
              </Link>
            </li>
            <li className={`sidebar-header ${!sidebarExpanded ? 'hide-text' : ''} `}>
              <div className='d-flex align-items-center '>
                <span className='me-2'>{t('tools')}</span>
                <div
                  className='flex-grow-1'
                  style={{
                    borderTop: '1px solid #80a0a9', // 👈 your custom color
                    opacity: 0.6,
                  }}
                ></div>
              </div>
            </li>
            {isFlagEnabled('ADMIN_ALERTS') && (
              <li
                className={`nav-item ${location.pathname == '/tools/page-alerts' ? 'active' : ''}`}
              >
                <Link className='nav-link' to='/tools/page-alerts'>
                  {icons && (
                    <span className='nav-link-icon d-md-none d-lg-inline-block'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='icon icon-thick icon-tabler icon-tabler-playlist-add'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        strokeWidth='2'
                        stroke='currentColor'
                        fill='none'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      >
                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                        <path d='M19 8h-14' />
                        <path d='M5 12h9' />
                        <path d='M11 16h-6' />
                        <path d='M15 16h6' />
                        <path d='M18 13v6' />
                      </svg>
                    </span>
                  )}
                  <span
                    className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}
                  >
                    {t('alerts')}
                  </span>
                </Link>
              </li>
            )}
            <li
              className={`nav-item ${location.pathname == '/tools/adjustments' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/tools/adjustments'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-playlist-add'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M19 8h-14' />
                      <path d='M5 12h9' />
                      <path d='M11 16h-6' />
                      <path d='M15 16h6' />
                      <path d='M18 13v6' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('adjustments')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/schedule' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/schedule'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-calendar'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z' />
                      <path d='M16 3v4' />
                      <path d='M8 3v4' />
                      <path d='M4 11h16' />
                      <path d='M11 15h1' />
                      <path d='M12 15v3' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('calendar')}
                </span>
              </Link>
            </li>
            <li className={`nav-item ${location.pathname == '/media' ? 'active' : ''}`}>
              <Link className='nav-link' to='/media'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-library-photo'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z' />
                      <path d='M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1' />
                      <path d='M17 7h.01' />
                      <path d='M7 13l3.644 -3.644a1.21 1.21 0 0 1 1.712 0l3.644 3.644' />
                      <path d='M15 12l1.644 -1.644a1.21 1.21 0 0 1 1.712 0l2.644 2.644' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('documents')} &amp; {t('media')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/training' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/training'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icons-tabler-outline icon-tabler-school'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M22 9l-10 -4l-10 4l10 4l10 -4v6' />
                      <path d='M6 10.6v5.4a6 3 0 0 0 12 0v-5.4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('trainingCourses')}
                </span>
              </Link>
            </li>
            <li className={`nav-item ${location.pathname == '/faq' ? 'active' : ''}`}>
              <Link className='nav-link' to='/faq'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-building-store'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M3 21l18 0' />
                      <path d='M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4' />
                      <path d='M5 21l0 -10.15' />
                      <path d='M19 21l0 -10.15' />
                      <path d='M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('faq')}
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${location.pathname == '/settings/company' ? 'active' : ''}`}
            >
              <Link className='nav-link' to='/settings/company'>
                {icons && (
                  <span className='nav-link-icon d-md-none d-lg-inline-block'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='icon icon-thick icon-tabler icon-tabler-adjustments-horizontal'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      strokeWidth='2'
                      stroke='currentColor'
                      fill='none'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                      <path d='M4 6l8 0' />
                      <path d='M16 6l4 0' />
                      <path d='M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                      <path d='M4 12l2 0' />
                      <path d='M10 12l10 0' />
                      <path d='M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                      <path d='M4 18l11 0' />
                      <path d='M19 18l1 0' />
                    </svg>
                  </span>
                )}
                <span className={`nav-link-title ${!sidebarExpanded ? 'hide-text' : ''}`}>
                  {t('settings')}
                </span>
              </Link>
            </li>
          </>
        )}
      </ul>
    </>
  );
};

export default CorporateMenu;
